import React, { useState } from 'react';
import { removeCableConnection } from '../../../../../services/kvsConnectionService';

interface RemoveCableButtonProps {
  kvsId: string;
  cableId: string;
  onRemoved: () => void;
}

export const RemoveCableButton: React.FC<RemoveCableButtonProps> = ({ kvsId, cableId, onRemoved }) => {
  const [isRemoving, setIsRemoving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRemove = async () => {
    if (!window.confirm('Sind Sie sicher, dass Sie diese Verbindung entfernen möchten?')) {
      return;
    }

    setIsRemoving(true);
    setError(null);

    try {
      await removeCableConnection(kvsId, cableId);
      onRemoved();
    } catch (err) {
      console.error('Failed to remove cable connection:', err);
      setError('Verbindung konnte nicht entfernt werden');
    } finally {
      setIsRemoving(false);
    }
  };

  return (
    <div>
      <button
        onClick={handleRemove}
        disabled={isRemoving}
        className="text-xs text-red-600 dark:text-error hover:text-red-800 dark:hover:text-error/80 disabled:opacity-50"
      >
        {isRemoving ? 'Wird entfernt...' : 'Entfernen'}
      </button>
      {error && <div className="text-xs text-red-600 dark:text-error mt-1">{error}</div>}
    </div>
  );
};